class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  updateTextQuantities (parsedState, config) {
    let quantity = 1;
    const addTextContent = this.notification.querySelector("#AddTextContent");

    if (config.body instanceof FormData) {
      quantity = config.body.get("quantity");
    }
    if (typeof config.body == 'string') {
      let body = JSON.parse(config.body);
      if (body.properties && body.properties['_gift-threshold']) {
        addTextContent.textContent = `Free item added to your cart!`;
        return;
      }
    }

    if (addTextContent && quantity > 1) {
      addTextContent.textContent = `${quantity} Items added to your cart`;
    } else if (addTextContent && quantity == 1) {
      addTextContent.textContent = `Item added to your cart`;
    } else {
      addTextContent.textContent = `Item added to your cart`;
    }
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, config) {
      const variantId = config.body.get('id');
      const sellingPlan = config.body.get('selling_plan')
      this.cartItemKey = `${variantId}${sellingPlan ? "-"+sellingPlan: ""}`;
      this.getSectionsToRender().forEach((section => {
        let id = section.id
        if (id == "cart-drawer") {
          if (window.location.pathname == "/cart") {
            id = "CartDrawer"
          } else {
            return;
          }
        }
        if (section.selector){
          if (section.selector.includes("undefined")) section.selector = section.selector.replaceAll("undefined", window.variantId);
         }
        document.getElementById(id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();

      this.updateTextQuantities(parsedState, config);

      if (typeof syncTieredPromotionGifts === 'function') {
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((cartResponse) => cartResponse.json())
          .then((cartData) => syncTieredPromotionGifts(cartData, {
            // The notification response predates the auto-added gift. Redraw the cart surface
            // from the synced cart instead of navigating away from the current product page.
            onCartMutated: () => loadCartAPI(false)
          }))
          .catch((error) => console.error(error));
      }

      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
